<template>
  <swiper :options="swiperOption" ref="mySwiper"  :on-slideChange="onSlideChange">
    <swiper-slide  v-for="(item, index) in swiperData" :key="index">
      <slot :item="{...item, index: index}" ></slot>
    </swiper-slide>
    <div class="swiper-pagination" :style="{'textAlign': paginationAlign}" slot="pagination"></div>
  </swiper>
</template>
<script>

import { Swiper, SwiperSlide} from 'vue-awesome-swiper'
import "swiper/css/swiper.css";
export default {
  name: 'index',
  components: { SwiperSlide, Swiper },
  data() {
    return {
      swiperOption: {
        // API
        pagination: {
          el: '.swiper-pagination',
          clickable :true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        loop: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 5000,
        },
        on: {
          slideChangeTransitionStart:  () =>  {
            if (this.$refs.mySwiper && this.$refs.mySwiper.$swiper) {
              this.$emit('slideChange', this.$refs.mySwiper.$swiper.realIndex)
            }
          },
          init ()  {
            this.slideToLoop(1, 0); // 确保从第一张开始
          }
        }
      },
    }
  },
  props: {
    option: {
      type: Object,
      default: () => {}
    },
    swiperData: {
      type: Array,
      default: () => []
    },
    paginationAlign: {
      type: String,
      default: 'center'
    }
  },
  mounted () {
    if (this.option) {
      this.swiperOption = {...this.swiperOption, ...this.option}
    }

  },
  methods: {
    onSlideChange(swiper) {
      console.log(swiper, 'onSlideChange')
      this.$emit('onSlideChange', swiper)
    }
  }
}
</script>


<style scoped lang="less">
.swiper-pagination{
  padding: 0 40px;
}
</style>